/**
 * Spacing CSS Generator
 *
 * Generate complete CSS for spacing control group using responsive CSS generator.
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { generateResponsiveCSS } from '../../common';
import type { SpacingAttributes } from '../types';
import { generateSpacingCSSRules } from './rules';

/**
 * Generate complete CSS for spacing control group
 */
export const getSpacingCSS = (
	attributes: SpacingAttributes,
	selector: string = '',
): string => {
	return generateResponsiveCSS(
		attributes,
		selector,
		generateSpacingCSSRules,
	);
};
